/**
 * SOJ Core Modern — Main JavaScript Entry Point
 *
 * @package SOJ_Core_Modern
 * @since 2.0.0
 */

import core from "./core.js";
import "./modules/background-video.js";

import AnimationSystem from "./modules/animations.js";
import GSAPAnimationSystem from "./modules/gsap-animations.js";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ExpoScaleEase } from "gsap/EasePack";
import { Draggable } from "gsap/Draggable";
import { InertiaPlugin } from "gsap/InertiaPlugin";

import $ from "jquery";
import "slick-carousel";

import SmoothScroll from "./modules/smooth-scroll.js";

window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
window.Draggable = Draggable;
window.InertiaPlugin = InertiaPlugin;
gsap.registerPlugin(ScrollTrigger, Draggable, InertiaPlugin, ExpoScaleEase);
// "load" is left out: SmoothScroll refreshes after load once scrolling is idle
ScrollTrigger.config({
  ignoreMobileResize: true,
  autoRefreshEvents: "visibilitychange,DOMContentLoaded,resize",
});

window.$ = $;
window.jQuery = $;

let animationSystem;
let gsapAnimationSystem;
let smoothScroll;

function initLearnMoreAccordions() {
  if (!document.querySelector(".et-learn-more .heading-more")) {
    return;
  }

  jQuery(".et-learn-more .heading-more").on("click", function (e) {
    e.preventDefault();
    const $heading = jQuery(this);
    const $accordion = $heading.closest(".et-learn-more");
    const $content = $accordion.find(".learn-more-content");
    if ($content.length === 0) return;
    $content.slideToggle(300);
    $accordion.toggleClass("et-learn-more-open");
    const isOpen = $accordion.hasClass("et-learn-more-open");
    $heading.attr("aria-expanded", isOpen ? "true" : "false");
  });
}

document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector(".animate")) {
    animationSystem = new AnimationSystem();
    window.SOJ_ANIMATIONS = animationSystem;
  }

  document.addEventListener("sliderInitialized", () => {
    window.setTimeout(() => {
      smoothScroll?.scheduleRefreshDimensions?.();
    }, 320);
  });

  smoothScroll = new SmoothScroll();
  window.SOJ_SMOOTH_SCROLL = smoothScroll;

  const startGsap = () => {
    if (gsapAnimationSystem) {
      return;
    }
    gsapAnimationSystem = new GSAPAnimationSystem();
    window.SOJ_GSAP_ANIMATIONS = gsapAnimationSystem;
  };

  if (typeof window.requestIdleCallback === "function") {
    window.requestIdleCallback(startGsap, { timeout: 1200 });
  } else {
    queueMicrotask(startGsap);
  }

  initLearnMoreAccordions();
});

export default core;
